// Scrolling while the cursor is in a number field changes the number in the
// browser instead of scrolling the page: a price or a number of days changed
// by accident while scrolling the product form. Here the wheel scrolls the
// page (or the open dialog) as it does everywhere else, for every number
// field in the CMS; the arrow keys still step the number.

// Pixels per line, when the wheel counts in lines (deltaMode 1).
const LINE = 16;

const canScroll = (el, dy, dx) => {
  const style = window.getComputedStyle(el);
  const y = /(auto|scroll|overlay)/.test(style.overflowY) && el.scrollHeight > el.clientHeight;
  const x = /(auto|scroll|overlay)/.test(style.overflowX) && el.scrollWidth > el.clientWidth;
  const moreY = dy > 0 ? el.scrollTop + el.clientHeight < el.scrollHeight : dy < 0 && el.scrollTop > 0;
  const moreX = dx > 0 ? el.scrollLeft + el.clientWidth < el.scrollWidth : dx < 0 && el.scrollLeft > 0;
  return (y && moreY) || (x && moreX);
};

/** The nearest box around the field that can still scroll that way, else null (the page). */
export function scrollTargetOf(el, dy, dx = 0) {
  for (let box = el.parentElement; box && box !== document.body && box !== document.documentElement; box = box.parentElement) {
    if (canScroll(box, dy, dx)) return box;
  }
  return null;
}

/** Listens on the whole document; returns the function that stops it. */
export function keepWheelForScrolling(doc = document) {
  const onWheel = (event) => {
    const field = event.target;
    if (!(field instanceof window.HTMLInputElement) || field.type !== "number" || doc.activeElement !== field) return;
    event.preventDefault();
    const unit = event.deltaMode === 1 ? LINE : event.deltaMode === 2 ? window.innerHeight : 1;
    const dy = event.deltaY * unit;
    const dx = event.deltaX * unit;
    const box = scrollTargetOf(field, dy, dx);
    if (box) box.scrollBy({ top: dy, left: dx });
    else window.scrollBy({ top: dy, left: dx });
  };
  // Not passive: only a listener that may cancel the wheel stops the change.
  doc.addEventListener("wheel", onWheel, { passive: false, capture: true });
  return () => doc.removeEventListener("wheel", onWheel, { capture: true });
}
